import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideRouter } from '@angular/router';
import { provideNgxMask } from 'ngx-mask';

import { pipesProviders } from '@cpcac/common/shared/pipes/pipes-providers';
import { environment } from '@cpcac/common/environments/environment';
import { materialProviders } from '@cpcac/common/shared/providers/material-providers';
import { initializeAnalytics } from '@cpcac/common/core/services/analytics';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';

if (environment.production) {
  enableProdMode();
}

let defaultLanguage = 'en';

switch (environment.country) {
  case 'US':
    defaultLanguage = 'en';
    break;
  case 'CN':
    defaultLanguage = 'zh';
    break;
}

initializeAnalytics();

bootstrapApplication(AppComponent, {
  providers: [
    ...pipesProviders,
    ...materialProviders,
    importProvidersFrom(BrowserModule),
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      lang: defaultLanguage,
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
    }),
    provideRouter(routes),
    provideNgxMask(),
  ],
})
  .catch(err => console.error(err));
